module.exports = __webpack_public_path__ + "img/1558741043.c7efe1f0.jpg";